import ApiBase from './api-base'

export default class Transports extends ApiBase {
  constructor (store) {
    const endpoint = 'courier/transports'
    super(store, endpoint)
  }

  getLicenseById (transportId, licenceId, showProgress) {
    return this._request({
      action: `${this._urlencode(transportId)}/licenses/${this._urlencode(licenceId)}`,
      method: 'GET',
      showProgress
    })
  }

  getAllLicenses (transportId, filter, showProgress) {
    return this._request({
      action: `${this._urlencode(transportId)}/licenses`,
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  createLicense (transportId, model, showProgress) {
    return this._request({
      action: `${this._urlencode(transportId)}/licenses`,
      method: 'POST',
      body: model,
      showProgress
    })
  }

  updateLicense (transportId, licenceId, model, showProgress) {
    return this._request({
      action: `${this._urlencode(transportId)}/licenses/${this._urlencode(licenceId)}`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  deleteLicense (transportId, licenceId, showProgress) {
    return this._request({
      action: `${this._urlencode(transportId)}/licenses/${this._urlencode(licenceId)}`,
      method: 'DELETE',
      showProgress
    })
  }

  getRecord (id, licenseId, filter, showProgress) {
    return this._request({
      action: `${this._urlencode(id)}/licenses/${this._urlencode(licenseId)}/record`,
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
